import React, { FC } from 'react';
import clsx from 'clsx';
import { Typography, Icon } from '@npm-registry/eapteka-ui';
import { useSelector } from 'react-redux';
import {
  selectIsERecipeAvailable,
  selectLoading
} from '../../../store/summary';
import { RecipeProps } from './types';
import { text } from '../../../text';
import styles from './Recipe.scss';

export const Recipe: FC<RecipeProps> = ({ className }) => {
  const loading = useSelector(selectLoading);
  const isERecipeAvailable = useSelector(
    selectIsERecipeAvailable
  );
  const rootClassNames = clsx([styles.root, className]);

  if (loading === 'idle' || !isERecipeAvailable) {
    return null;
  }

  return (
    <div className={rootClassNames}>
      <div>
        <Icon
          className={styles.icon}
          name="roundSpeechBubbleExclamation"
        />
      </div>
      <div>
        <Typography
          className={styles.title}
          weight="strong"
        >
          {text['recipe.title']}
        </Typography>
        <Typography
          className={styles.description}
          variant="p2"
        >
          {text['recipe.description']}
        </Typography>
      </div>
    </div>
  );
};
